import React from 'react';
import { useNavigate } from 'react-router-dom';
import './terms.css';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="termsContainer">
      <div className="termHeader">
        <h1>TailTrace Policies</h1>
        <p className="termSubheader">
          Your privacy and safety are our top priority. Please review our policies below.
        </p>
      </div>

      <h2>Privacy & Terms</h2>
      <p>
        TailTrace is committed to protecting your data and providing a safe community for pet owners.
      </p>

      <div className="policyLinks">
        <a
          href="https://app.termly.io/policy-viewer/policy.html?policyUUID=1888dbe1-f753-4129-90a9-e0b1ba64a352"
          target="_blank"
          rel="noopener noreferrer"
          className="policyCard"
        >
          <span className="policyIcon">🔒</span>
          <span>Privacy Policy</span>
          <span className="policyArrow">→</span>
        </a>
        <a
          href="https://app.termly.io/policy-viewer/policy.html?policyUUID=7d9744ab-9eb1-4b93-b7e9-e2d30afea196"
          target="_blank"
          rel="noopener noreferrer"
          className="policyCard"
        >
          <span className="policyIcon">📄</span>
          <span>Terms of Use</span>
          <span className="policyArrow">→</span>
        </a>
        <button
          onClick={() => navigate('/child-safety')}
          className="policyCard policyCardButton"
        >
          <span className="policyIcon">🛡️</span>
          <span>Child Safety Standards</span>
          <span className="policyArrow">→</span>
        </button>
      </div>

      <h2>Community Guidelines</h2>
      <p>
        TailTrace is a community built on trust. All users are expected to post accurate information
        about lost and found pets. Misuse of the platform including false reports or harassment
        may result in account suspension. Users can report and block accounts that violate these guidelines.
      </p>

      <h2>Contact</h2>
      <p>
        For questions or support, reach us at{' '}
        <a href="mailto:tailtracehq@gmail.com">tailtracehq@gmail.com</a>.
      </p>
    </div>
  );
};

export default Terms;